module.exports = __webpack_public_path__ + "img/img.dd8e451b.png";